export const amountValueTypeConstants = [
    { name: "Flat", value: "flat" },
    { name: "Percentage", value: "percentage" },
    { name: "Multiplied", value: "multiplied" },

];
  